export function processObjToArrayInMonth(dataArray) {
	const yearMap = new Map();

	dataArray.forEach((item) => {
		const date = new Date(item.date);
		const year = date.getFullYear().toString();
		const month = date.getMonth() + 1;
		const count = item.count;

		if (!yearMap.has(year)) {
			yearMap.set(year, Array(12).fill(0));
		}

		yearMap.get(year)[month - 1] += count;
	});

	const result = [];
	yearMap.forEach((months, year) => {
		result.push({ year: year, data: months });
	});
	result.sort((a, b) => b.year - a.year);

	return result;
}

export const convertRevenueData = (input) => {
	const allIndustries = new Set();
	Object.values(input)?.forEach((yearData) => {
		yearData.forEach((item) => {
			const industryName = item?.industry?.toLowerCase()?.replace(/\s+/g, "_");
			allIndustries.add(industryName);
		});
	});

	return Object.keys(input).map((year) => {
		const yearData = input[year]?.reduce(
			(acc, industry) => {
				const industryName = industry?.industry?.toLowerCase()?.replace(/\s+/g, "_");
				acc[industryName] = industry?.revenue;
				return acc;
			},
			{ name: year }
		);

		// Ensure all industries are present
		allIndustries?.forEach((industry) => {
			if (!(industry in yearData)) {
				yearData[industry] = 0;
			}
		});

		return yearData;
	});
};

export function convertCapitalize(str) {
	let words = str.split("_");
	for (let i = 0; i < words.length; i++) {
		words[i] = words[i]?.charAt(0).toUpperCase() + words[i].slice(1);
	}

	let result = words.join(" ");

	return result;
}

export function convertTimestamp(timestamp) {
	// Parse the timestamp
	const dt = new Date(timestamp);

	// Get the current date
	const now = new Date();
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	const yesterday = new Date(today);
	yesterday.setDate(today.getDate() - 1);

	// Format the time
	let hours = dt.getHours();
	const minutes = dt.getMinutes();
	const ampm = hours >= 12 ? "PM" : "AM";
	hours = hours % 12;
	hours = hours ? hours : 12; // the hour '0' should be '12'
	const minutesStr = minutes < 10 ? "0" + minutes : minutes;
	const timeStr = hours + ":" + minutesStr + " " + ampm;

	// Check if the date is today, yesterday, or any other day
	let dateStr;
	if (dt >= today) {
		dateStr = "Today";
	} else if (dt >= yesterday) {
		dateStr = "Yesterday";
	} else {
		const day = dt.getDate();
		const month = dt.getMonth() + 1; // Months are zero-based
		const year = dt.getFullYear();
		dateStr = `${year}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}`;
	}

	return `${timeStr}, ${dateStr}`;
}

export function formatDateToISO8601() {
	const date = new Date();

	// Get date components
	const year = date.getUTCFullYear();
	const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-based
	const day = String(date.getUTCDate()).padStart(2, "0");

	// Get time components
	const hours = String(date.getUTCHours()).padStart(2, "0");
	const minutes = String(date.getUTCMinutes()).padStart(2, "0");
	const seconds = String(date.getUTCSeconds()).padStart(2, "0");
	const milliseconds = String(date.getUTCMilliseconds()).padStart(3, "0");

	// Format the date and time string
	const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;

	return isoString;
}
